import dynamic from "next/dynamic";
import React from "react";
const DynamicMapEventLayer = dynamic(() => import("./MapEventLayerRaw"), {
  ssr: false
});
const MapEventLayer = (props: React.ComponentProps<typeof DynamicMapEventLayer>) => {
  return <DynamicMapEventLayer {...props} data-sentry-element="DynamicMapEventLayer" data-sentry-component="MapEventLayer" data-sentry-source-file="MapEventLayer.tsx" />;
};
export default MapEventLayer;